<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
        <div class="container-fluid">
            <router-link class="navbar-brand" to="/hoshitsuki">
                <img src="@/hoshitsuki/assets/logo_hoshitsuki.png" class="logo" alt="ホシツキ">
            </router-link>
            <router-link to="/hoshitsuki" class="btn btn-sm btn-light"><i class="bi bi-house"></i>もどる</router-link>
            <h5 class="ms-auto me-3 mb-0">
                <i class="text-secondary bi bi-cloud-slash" v-if="$store.state.hoshitsuki.note.is_offline"></i>
                <i class="text-secondary bi bi-cloud-upload blink" v-else-if="$store.state.hoshitsuki.note.is_syncing"></i>
                <i class="text-secondary bi bi-cloud-check" v-else></i>
            </h5>
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse justify-content-end flex-0" id="navbarSupportedContent">
                <ul class="navbar-nav">
                    <li class="nav-item">
                        <a class="nav-link" target="_blank" href="/guide/hoshitsuki-for-students.pdf"><i class="bi bi-question-circle"></i> {{ $t('使い方') }}</a>
                    </li>
                    <li class="nav-item dropdown" v-if="$store.state.hoshitsuki.auth.is_signed_in">
                        <a class="nav-link dropdown-toggle" href="#" id="systemDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i class="bi bi-person-circle"></i> <span v-if="$store.state.hoshitsuki.auth.student_name">{{ $store.state.hoshitsuki.auth.student_name }} さん</span>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="systemDropdown">
                            <li>
                                <a class="nav-link text-black" href="#" @click="signOut()">ログアウト</a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </nav>

    <div class="container-main container-md">
        <div class="card">
            <div class="card-header">
                <h2 class="mb-0"><i class="bi bi-book text-primary"></i> {{ $t('観察') }}ノート</h2>
            </div>
            <div class="card-body">
                <div class="text-center mb-3">
                    <button-exec-edit
                        :text="$t('新しい') + ` ` + $t('観察') + `ノートをつくる`"
                        icon="bi-plus"
                        type="button"
                        @click="show_create_modal = true"
                    ></button-exec-edit>
                </div>

                <div class="list-group">
                    <template
                        v-for="note of $store.getters['hoshitsuki/note/list']($store.state.hoshitsuki.auth.account_user_id)"
                        :key="note.uuid"
                    >
                        <router-link
                            v-if="!note.is_deleted"
                            :to="{name: 'PageNoteEdit', params: {uuid: note.uuid}}"
                            class="list-group-item"
                        >
                            {{ note.note_title }} <small>({{ $helper.ymd(note.note_date) }})</small>
                        </router-link>
                    </template>
                </div>
            </div>
        </div>
    </div>

    <!-- 作品追加モーダル -->
    <div ref="modal_create_note" v-if="show_create_modal">
        <transition name="fade">
            <div v-if="show_create_modal">
                <div class="modal-backdrop show"></div>
                <div class="modal" tabindex="-1" style="display:block">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title">{{ $t('観察') }}ノートをつくる</h4>
                                <button type="button" class="btn-close" @click="show_create_modal = false"></button>
                            </div>
                            <div class="modal-body">
                                <form @submit.prevent="createNote">
                                    <label class="form-label">タイトル</label>
                                    <input type="text" v-model="new_note_title" required class="form-control">
                                    <div class="text-center mt-4">
                                        <button-exec-edit :text="$t('観察') + `ノートをつくる`"></button-exec-edit>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import ButtonExecEdit from '../../shared/components/design/buttons/ButtonExecEdit.vue';
import { v4 as uuidv4 } from 'uuid'

export default {
    name: 'PageNoteList',
    components: {
        ButtonExecEdit
    },
    inject: [
        'startScreenLoading',
        'endScreenLoading',
        'showMessage',
        'showErrorMessage',
        'signOut',
    ],
    data() {
        return {
            show_create_modal: false,
            new_note_title: this.$t('新しい') + this.$t('観察') + 'ノート',
        }
    },
    mounted() {
        // データの同期
        this.$store.dispatch('hoshitsuki/note/sync', this.$store.state.hoshitsuki.auth.account_user_id);
    },
    methods: {
        createNote() {
            /* オフライン使用を想定して、UUIDで管理 */
            let note = {
                note_id: null,
                uuid: uuidv4(),
                account_user_id: this.$store.state.hoshitsuki.auth.account_user_id,
                note_title: this.new_note_title,
                note_date: this.$helper.today(),
                marks: [],
                direction: 0,
                is_submitted: 0,
                is_deleted: 0,
                last_modified: this.$helper.now(),
            };
            this.$store.commit('hoshitsuki/note/create', note);
            this.$store.dispatch('hoshitsuki/note/sync', this.$store.state.hoshitsuki.auth.account_user_id);
            this.$router.push({name: 'PageNoteEdit', params: {uuid: note.uuid}});
        },
    },
}
</script>

<style scoped>
</style>
